import "./SignIn.scss"
import sidebarBanner from "../../assets/images/banners/backforSignUP.png"
import React, {useEffect, useState} from "react";
import RaikoLineStepper from "../../raikoComponents/raikoLineStepper/RaikoLineStepper";
import {Link, Navigate, Route, Routes, useLocation} from "react-router-dom";
import SignInEnterPhoneNumber from "./signInEnterPhoneNumber/SignInEnterPhoneNumber";
import {RouteInfo} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import SignInEnterSubmitCode from "./signInEnterSubmitCode/SignInEnterSubmitCode";
import SignInForgetPassword from "./signInForgetPassword/SignInForgetPassword";
import SignInRefreshPassword from "./signInRefreshPassword/SignInRefreshPassword";
import {RaikoBaseCardContainer} from "@moeindal/base-raiko-panel-components";

const SignIn = () => {

    const [steps, setSteps] = useState(1);

    const location = useLocation()


    function handleChangeStep(newStep) {
        setSteps(newStep)
    }

    useEffect(() => {

        if (location.pathname === RouteInfo.SignInEnterPhoneNumber.globalUrl) {
            handleChangeStep(1)
        } else if (location.pathname === RouteInfo.SignInEnterSubmitCode.globalUrl) {
            handleChangeStep(2)
        }

    }, [location.pathname]);

    return (
        <>
            <div className={"baseSignInContainer"}>
                <RaikoBaseCardContainer className={"signInPageContainer"}>
                    <div className={"signInPageContentContainer"}>

                        <div className={"pageInfoContainer"}>
                            <div className={css`height: 100%;
                              width: 100%;`}>
                                <Routes>
                                    <Route
                                        path={RouteInfo.SignInEnterPhoneNumber.url}
                                        element={<SignInEnterPhoneNumber/>}
                                    />
                                    <Route
                                        path={RouteInfo.SignInEnterSubmitCode.url}
                                        element={<SignInEnterSubmitCode/>}
                                    />
                                    <Route
                                        path={RouteInfo.SignInForgetPassword.url}
                                        element={<SignInForgetPassword/>}
                                    />
                                    <Route
                                        path={RouteInfo.SignInRefreshPassword.url}
                                        element={<SignInRefreshPassword/>}
                                    />
                                    <Route
                                        path={"/*"}
                                        element={<Navigate replace to={RouteInfo.SignInEnterPhoneNumber.globalUrl}/>}
                                    />
                                </Routes>
                            </div>
                            <RaikoLineStepper numberOfSteps={3} currentStep={steps}/>
                        </div>
                        {/*<div className={"pageSubInfoContainer"}>
                        <div className={"pageSubInfoHelperLinkContainer"}>
                            <Link to={"/"}>
                                <span>راهنمای ثبت نام</span>
                            </Link>
                            <span>|</span>
                            <Link to={"/"}>
                                <span>تماس با پشتیبانی</span>
                            </Link>
                        </div>
                    </div>*/}
                    </div>
                    {/*<img src={sidebarBanner} alt="banner" className={"sidebarBanner"}/>*/}
                </RaikoBaseCardContainer>
            </div>
        </>
    )
}

export default SignIn;